var map = {
	"./CANCION.png": "d59d",
	"./CANCION_PEDIDA.png": "99ca",
	"./PLAY.png": "2222",
	"./REGRESAR.png": "27ea",
	"./REGRESAR_PRESS.png": "ae4c",
	"./VISITANOS-APP.png": "5bfe",
	"./loading.gif": "d704",
	"./loguito.png": "8522",
	"./placeholder.png": "4f55",
	"./rayas_app_a.png": "a376",
	"./rayas_app_b.png": "c7f5",
	"./titulo_app.png": "656b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "af1b";